type AddOnSectionLike<TMenuObject extends { _id: string }> = {
  options?: Array<{
    option?: TMenuObject | null;
  } | null> | null;
};

type CartEntryLike = {
  _id?: string;
  id?: string;
  isDonation?: boolean;
};

export const isMenuObjectInAddOnSections = <TMenuObject extends { _id: string }>(
  menuObjectId: string,
  sections: AddOnSectionLike<TMenuObject>[]
) => {
  return sections.some(section =>
    (section.options ?? []).some(option => option?.option?._id === menuObjectId)
  );
};

const getCartEntryId = (entry: CartEntryLike) => entry.id ?? entry._id ?? '';

export const cartHasLegacyOrderableEntries = (cartEntries: CartEntryLike[]) => {
  return cartEntries.some(entry => !entry.isDonation);
};

export const isLegacyCondimentsOnlyCart = <TMenuObject extends { _id: string }>(
  cartEntries: CartEntryLike[],
  sections: AddOnSectionLike<TMenuObject>[],
  ignoredEntryIds: Iterable<string> = []
) => {
  const ignoredEntryIdsSet = new Set(ignoredEntryIds);
  const relevantEntries = cartEntries.filter(entry => {
    if (entry.isDonation) {
      return false;
    }

    return !ignoredEntryIdsSet.has(getCartEntryId(entry));
  });

  if (!relevantEntries.length) {
    return false;
  }

  return relevantEntries.every(entry =>
    isMenuObjectInAddOnSections(getCartEntryId(entry), sections)
  );
};
